import BaseController from "confinus_ui/base_controller";

export default class extends BaseController {
  static targets = ["recipientsSection", "visibilitySelect"];

  declare readonly recipientsSectionTarget: HTMLElement;
  declare readonly visibilitySelectTarget: HTMLSelectElement;

  connect() {
    this.toggleRecipients();
  }

  visibilityChanged() {
    this.toggleRecipients();
  }

  private toggleRecipients() {
    const isTargeted = this.visibilitySelectTarget.value === "targeted";
    this.recipientsSectionTarget.style.display = isTargeted ? "" : "none";
  }
}
